import Avatar from 'common/Avatar/Avatar'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { PlatformIcon } from 'screens/ScheduledPosts/PlatformIcon'
import { getInitials } from 'utils'
import Styles from './AccountAvatar.module.scss'

interface AccountAvatarProps {
  provider: ExternalIntegrationEnum
  avatarUrl?: string
  accountName: string
}

export const AccountAvatar = ({ provider, avatarUrl, accountName }: AccountAvatarProps) => (
  <span className={Styles.accountAvatar} data-testid={`account-avatar-${provider}`}>
    <Avatar size={16} url={avatarUrl} label={getInitials(accountName)} altText={accountName} />
    <span className={Styles.providerBadge} aria-hidden>
      <PlatformIcon platform={provider} size={8} isBrand />
    </span>
  </span>
)
